import React, { useState } from "react";
import { Container, Typography, TextField, Button } from "@mui/material";
import Sidebar from "../user/sidebar";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    /**logic to send the form data to the server or perform any other action*/
    console.log("Form submitted:", formData);
  };

  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
      <Sidebar />

      <div className="ml-4 flex-grow">
        <form onSubmit={handleSubmit} style={{ maxWidth: "400px" }}>
          <Typography variant="h5">Contact Us</Typography>
          <div className="grid grid-cols-1 gap-4 mt-4">
            <TextField
              label="Name"
              name="name"
              variant="outlined"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full"
            />
            <TextField
              label="Email"
              name="email"
              variant="outlined"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full"
            />
            <TextField
              label="Message"
              name="message"
              variant="outlined"
              multiline
              rows={4}
              required
              value={formData.message}
              onChange={handleChange}
              className="w-full"
            />
          </div>
          <div className="mt-4">
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </Container>
  );
}

export default ContactUs;
